import { Component, OnInit, Signal } from '@angular/core'
import { ProgressBarComponent } from '@components/progress-bar/progress-bar.component'
import { ProgressStep } from '../../../interfaces/progress-step.interface'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import {
    NaturalStoneFinalizePreorderCartComponent
} from '../natural-stone-finalize-preorder-cart/natural-stone-finalize-preorder-cart.component'
import { ButtonComponent } from '@components/button/button.component'
import { DecimalPipe, Location, NgIf } from '@angular/common'
import {
    NaturalStoneFinalizePreorderInfoComponent
} from '../natural-stone-finalize-preorder-info/natural-stone-finalize-preorder-info.component'
import { NaturalStoneService } from '../../../services/natural-stone.service'
import { Router } from '@angular/router'
import { ApiService } from '../../../services/api.service'
import { NaturalStoneLotParsed } from '../../../interfaces/natural-stone/natural-stone-lots'
import { NaturalStoneColorService } from '../../../services/natural-stone-color.service'
import { environment } from '../../../../environments/environment'
import { firstValueFrom } from 'rxjs'
import { LoadingService } from '../../../services/loading.service'
import { NaturalStoneCartLine } from '../../../interfaces/natural-stone/natural-stone-cart'

@Component({
  selector: 'app-natural-stone-finalize-preorder',
  standalone: true,
    imports: [
        ProgressBarComponent,
        NaturalStoneFinalizePreorderCartComponent,
        ButtonComponent,
        TranslateModule,
        NgIf,
        NaturalStoneFinalizePreorderInfoComponent
    ],
    providers: [DecimalPipe],
  templateUrl: './natural-stone-finalize-preorder.component.html',
  styleUrl: './natural-stone-finalize-preorder.component.scss'
})
export class NaturalStoneFinalizePreorderComponent implements OnInit{

    public progressSteps: ProgressStep[] = [
        { title: this.translate.instant('global.summary') },
        // { title: this.translate.instant('global.information') },
        { title: this.translate.instant('global.confirmation') },
    ]
    public step: number = 1

    public cart: Signal<NaturalStoneCartLine[]>

    constructor(
        private translate: TranslateService,
        private naturalStoneService: NaturalStoneService,
        private colorService: NaturalStoneColorService,
        private router: Router,
        private api: ApiService,
        private _decimalPipe: DecimalPipe,
        private loading: LoadingService,
        private location: Location
    ) {
    }

    ngOnInit() {
        this.naturalStoneService.isMinicartOpen.set(false)
        this.cart = this.naturalStoneService.cart
        if(this.cart().length === 0 || !this.naturalStoneService.selectedCenter()){
            this.router.navigate(['natural-stone'])
        }
    }

    async nextStep(isFinalStep = false) {
        if(!isFinalStep) {
            this.step++;
        } else {
            this.loading.show()
            firstValueFrom(this.api.confirmNaturalStoneSelection(await this.getParsedCart())).then(response => {
                this.loading.hide()
                if(response){
                    this.step++;
                    this.naturalStoneService.clearCart()
                } else {
                    console.error('Error confirming selection. Check backend')
                }
            }).catch(error => {
                this.loading.hide()
                console.error(error)
            })
        }
    }


    async getParsedCart(){
        const cartLinePromises = this.naturalStoneService.cart().map(async cartLine => {
            const finishText = await this.colorService.getFinish(cartLine.color.finish!) || ''
            const thicknessText = this.colorService.getThicknessText(cartLine.color.thickness!, this._decimalPipe);
            const surfaceAreaPerSlabText = this.colorService.getSurfaceAreaText(cartLine.lot, this._decimalPipe)
            const surfaceAreaTotalText = this.colorService.getSurfaceAreaText(cartLine.lot, this._decimalPipe, cartLine.qty)
            const measurementsText = this.colorService.getMeasurementsText(cartLine.lot, this._decimalPipe)

            const parsedLine: NaturalStoneLotParsed = {
                colorName: this.colorService.getColorText(cartLine.color) || '',
                sku: cartLine.color.sku || '',
                brand: this.colorService.getBrandText(cartLine.color) || '',
                finish: finishText,
                thickness: thicknessText,
                lotId: cartLine.lot.lotId || '',
                bundleId: cartLine.lot.bundleId || undefined,
                surfaceAreaPerSlab: surfaceAreaPerSlabText,
                surfaceAreaTotal: surfaceAreaTotalText,
                measurements: measurementsText,
                priceGroup: cartLine.color.priceGroup || '',
                qty: cartLine.qty,
                imageUrl: cartLine.color.imageUrl || '',
                itemUrl: `${environment.publicUrl}/natural-stone/lots/${this.naturalStoneService.selectedCenter()}/${cartLine.color.sku}/${cartLine.lot.lotId}`
            }

            return parsedLine;
        })

        const output: NaturalStoneLotParsed[] = []
        for(let linePromise of cartLinePromises){
            output.push(await linePromise)
        }

        return output;
    }

    isFinalStep(){
        return this.step === this.progressSteps.length
    }

    goBackToSelection() {
        this.naturalStoneService.clearCart()
        this.router.navigate(['natural-stone'])
    }

    goBack(){
        this.location.back()
    }
}
